import capitalize from './capitalize';

const formatLastName = (input: string) => {
  if (!input) return '';

  // Double capitalization to handle lastnames such as O'Hare (O and H)
  if (input[1] === "'") {
    return `${input[0].toUpperCase()}'${input.slice(2, 3).toUpperCase()}${input
      .slice(3)
      .toLowerCase()}`;
  }

  // Regular capitalization
  return capitalize(input);
};

export default formatLastName;
